import React, { useState, useEffect, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { WithStyles, withStyles } from "@material-ui/core";
import { connect, ConnectedProps } from "react-redux";
import { styles } from "./AppbarStyles";
import MyToolbar from "./Toolbar/Toolbar";
import MyDrawer from "./Drawer/Drawer";
import Footer from "./Footer/Footer";
import MyDialog from "../UI/Dialog/Dialog";
import * as actionCreators from "../../store/actions";
import { TOKEN, REFRESH_TOKEN } from "../../constants";
import Loading from "../UI/Loading/Loading";
import { isNative2 } from "../../utils/helper";
import CRUDServices from "../Administracion/CRUDServices/CRUDServices";
import FormService from "../Administracion/CRUDServices/FormService/FormService";
import { Information } from "../Information/Information";
import { Datos0800Salud } from "../Datos/Datos0800Salud";
import { Datos0800AtencionAlVecino } from "../Datos/Datos0800AtencionAlVecino";
import { DatosMesaAyudaSistemas } from "../Datos/DatosMesaAyudaSistemas";
import { DatosDefensaCivil } from "../Datos/DatosDefensaCivil";

const Relaciones = React.lazy(() => import("../Relaciones/Relaciones"));
const MiCuenta = React.lazy(() => import("../MiCuenta/MiCuenta"));
const Servicios = React.lazy(() => import("../Servicios/Servicios"));
const Comunicaciones = React.lazy(
  () => import("../Comunicaciones/Comunicaciones")
);
const Representados = React.lazy(
  () => import("../Representados/Representados")
);
const ABMempleado = React.lazy(
  () => import("../Administracion/ABMempleado/ABMempleado")
);
const MisDocumentos = React.lazy(
  () => import("../MisDocumentos/MisDocumentos")
);
const Datos = React.lazy(() => import("../Datos/Datos"));
const ConfiguracionNotificaciones = React.lazy(
  () => import("../ConfiguracionNotificaciones/ConfiguracionNotificaciones")
);

/* link docs redux con typescript
https://redux.js.org/recipes/usage-with-typescript/#usage-with-redux-thunk*/
const mapDispatchToProps = (dispatch: any) => ({
  logout: () => dispatch(actionCreators.logout()),
  // fetchRoles: (appId: any) => dispatch(actionCreators.fetchRoles(appId)),
  actualizarRdosLegalesCiDiVedi: () =>
    dispatch(actionCreators.actualizarRdosLegalesCiDiVedi()),
});

const mapStateToProps = (state: any) => ({
  refreshToken: state.usuario.refreshToken,
  usuario: state.usuario.user,
});
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & WithStyles<typeof styles>;

const MyAppbar: React.FC<Props> = (props) => {
  const { classes, logout, actualizarRdosLegalesCiDiVedi, usuario } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const [dialog, setDialog] = useState<any>({ show: false });
  const [_loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      actualizarRdosLegalesCiDiVedi();
    } catch (error) {
      console.error("error actualizando representados");
    }
  }, [actualizarRdosLegalesCiDiVedi]);

  const handleDrawerToggle = () => {
    setMobileOpen((mobileOpen) => !mobileOpen);
  };

  const logoutHandler = async () => {
    const esNativo = await isNative2();
    setDialog({
      show: true,
      text: "¿Estas seguro que querés salir?",
      textCancelar: "No",
      textAceptar: "Si",
      cancelClicked: () => {
        setDialog((prevState: any) => ({ ...prevState, show: false }));
      },
      acceptClicked: () => {
        setDialog({ show: false });
        setLoading(true);

        logout()
          .then(() => {
            document.cookie = `${TOKEN}=; path=/`;
            document.cookie = `${REFRESH_TOKEN}=; path=/`;
            if (esNativo) {
              window.location.href = process.env
                .REACT_APP_CIDI_LOGOUT as string;
            } else {
              const cidi: Window | null = window.open(
                process.env.REACT_APP_CIDI_LOGOUT,
                "_blank"
              );
              if (cidi) {
                cidi.onload = () => {
                  cidi?.close();
                };
              }
            }
          })
          .catch((error: unknown) => console.error(error));
      },
    });
  };

  return (
    <React.Fragment>
      <Loading loading={_loading} />
      <MyDialog dialog={dialog} />
      <div className={classes.root}>
        <CssBaseline />
        <MyToolbar
          handleDrawerToggle={handleDrawerToggle}
          pathname={pathname}
          logoutHandler={logoutHandler}
        />
        <MyDrawer
          handleDrawerToggle={handleDrawerToggle}
          mobileOpen={mobileOpen}
        />
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Suspense fallback={<Loading loading={true} />}>
            <Routes>
              <Route path="/servicios/*" element={<Servicios />} />
              <Route path="/MisDocumentos" element={<MisDocumentos />} />
              <Route path="/comunicaciones" element={<Comunicaciones />} />
              <Route path="/mi-cuenta" element={<MiCuenta />} />
              <Route path="/representaciones/*" element={<Relaciones />} />
              <Route path="/representados/*" element={<Representados />} />
              <Route path="/informacion-util" element={<Information />} />
              <Route
                path="/configuracion-notificaciones"
                element={<ConfiguracionNotificaciones />}
              />
              {usuario.rol >= 1 ? (
                <>
                  <Route
                    path="/administracion-empleados"
                    element={<ABMempleado />}
                  />
                  <Route
                    path="/administracion-servicios"
                    element={<CRUDServices />}
                  />
                  <Route path="/alta-servicio" element={<FormService />} />
                  <Route path="/vista-servicio/:id" element={<FormService />} />
                  <Route
                    path="/editar-servicio/:id"
                    element={<FormService />}
                  />
                </>
              ) : null}
              {usuario.rol >= 4 ? (
                <>
                  <Route path="/datos" element={<Datos />} />
                  {/* <Route path="/datos-salud" element={<Datos0800Salud />} />
                  <Route
                    path="/datos-vecino"
                    element={<Datos0800AtencionAlVecino />}
                  />
                  <Route
                    path="/datos-mesa-ayuda"
                    element={<DatosMesaAyudaSistemas />}
                  />
                  <Route
                    path="/datos-defensa-civil"
                    element={<DatosDefensaCivil />}
                  /> */}
                </>
              ) : null}
              <Route path="*" element={<Navigate to="/servicios" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default withStyles(styles)(connector(MyAppbar)) as React.ComponentType;
